var map = {
	"./title-test-1.png": "WsWc",
	"./title-test-2.png": "MlTP",
	"./title-test-3.png": "pkF0"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "EbmK";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/report ^\.\/title\-test\-.*\.png$
// module id = EbmK
// module chunks = 1